import type { CoderuleClients, VisitorRulesV2 } from '@coderule/clients';
import type { Logger } from 'pino';

export async function fetchVisitorRules(
  clients: CoderuleClients,
  logger: Logger,
): Promise<VisitorRulesV2> {
  const fetchLogger = logger.child({ scope: 'rules' });
  fetchLogger.info('Fetching visitor rules v2 from AST service');
  const rules = await clients.ast.getVisitorRulesV2();
  fetchLogger.info(
    {
      include_extensions: rules.include_extensions.length,
      include_filenames: rules.include_filenames.length,
      exclude_dirnames: rules.exclude_dirnames.length,
    },
    'Fetched visitor rules',
  );
  return rules;
}
